import Vue from 'vue';
let thisVue = new Vue()

const state = {
    products: [],
    productsLabels: [],
    extras: [],
    extrasLabels: [],
    resources: [],
    resourcesLabels: [],
    categories: [],
    categoriesLabels: [],
    events: [],
    selectedItem: null,
    clonedItem: null,
    isAddingItem: false,
    productEditPriceData: null,
    isLoadingProducst: false,
    isLoadingExtras: false,
    isLoadingResources: false,
    isLoadingCategories: false,
    creatingNewResource: false,

    // ------ separation of items -> avoid using getSelectedItem for extras/servieces, products, etc
    selectedExtra: null,
    isAddingRouteToPickups: false,
    priceGroupSelected: []
};

const getters = {
    getProducts: (state) => state.products,
    getProductsLabels: (state) => state.productsLabels,
    getExtras: (state) => state.extras,
    getExtrasLabels: (state) => state.extrasLabels,
    getResources: (state) => state.resources,
    getResourcesLabels: (state) => state.resourcesLabels,
    getCategories: (state) => state.categories,
    getCategoriesLabels: (state) => state.categoriesLabels,
    getEvents: (state) => state.events,
    getEventsLabels: (state) => state.eventsLabels,
    getSelectedItem: (state) => state.selectedItem,
    getSelectedExtra: (state) => state.selectedExtra,
    getClonedItem: (state) => state.clonedItem,
    getProductEditPriceData: (state) => state.productEditPriceData,
    getPickupRoutes: (state) => state.pickupRoutes,
    getLoadingProducts: (state) => state.isLoadingProducst,
    getLoadingExtras: (state) => state.isLoadingExtras,
    getLoadingResources: (state) => state.isLoadingResources,
    getLoadingCategories: (state) => state.isLoadingCategories,
    getCreatingNewResource: (state) => state.creatingNewResource,
    getIsAddingItem: (state) => state.isAddingItem,
    getIsAddingRouteToPickups: (state) => state.isAddingRouteToPickups,
    getGroupPrices: (state) => state.priceGroupSelected,
};

const actions = {
    normalizeGenderPricesDeps({commit}) {
        commit('NORMALIZE_GENDER_PRICES_DEPS');
    },

    setCreatingNewResource({commit}, payload) {
        commit('CREATING_NEW_RESOURCE', payload)
    },

    async initProducts ({ dispatch, commit, getters, rootState }, data) {
        try {
			let onlyActive = !!data ? !data.showInactiveProducts : null // if we don't have data, we make the api call without onlyActive param
			if (!!localStorage.getItem('showInactiveProducts')) { // if we have the value saved in local storage, we use it to make the api call
				onlyActive = localStorage.getItem('showInactiveProducts') === 'false'
			}
            state.isLoadingProducst = true
            let response = await axios.get('/api/inventory/ListProduct', { params: {
				supplierId: rootState.user.account.supplierId,
				onlyActive: onlyActive
			}});
            state.isLoadingProducst = false
            if (response && response.status === 200 && response.data) {
                commit('INIT_PRODUCTS', {
                    products: response.data,
                    labels: {
                        name: 'Name',
                        code: 'Cost Center',
                        category: 'Category',
                    }
                });

                return true;
            }

            return false;
        }
        catch (error) {}
    },

    async initCategories({ commit, rootState, dispatch }) {
        try {
            state.isLoadingCategories = true
            let response = await axios.get('/api/inventory/ListCategory', { params: { supplierId: rootState.user.account.supplierId }});
            state.isLoadingCategories = false

            if (response && response.status === 200 && response.data) {
                commit('INIT_CATEGORIES', {
                    categories: response.data,
                    labels: {
                        name: 'Name',
                        // description: 'Description',
                        // status: 'Status',
                    }
                });

                return true;
            }

            return false;
        }
        catch (error) {
            //Vue.toasted.error(error);
        }
    },

    async initResources ({ commit, rootState, dispatch }, data) {
        try {
			let onlyActive = !!data ? !data.showInactiveResources : null // if we don't have data, we make the api call without onlyActive param
			if (!!localStorage.getItem('showInactiveResources')) { // if we have the value saved in local storage, we use it to make the api call
				onlyActive = localStorage.getItem('showInactiveResources') === 'false'
			}
            state.isLoadingResources = true
            let response = await axios.get('/api/inventory/ListResource', { params: {
				supplierId: rootState.user.account.supplierId,
				onlyActive: onlyActive
			}});
            state.isLoadingResources = false

            if (response && response.status === 200 && response.data) {
                commit('INIT_RESOURCES', {
                    resources: response.data,
                    labels: {
                        name: 'Name',
                        code: 'Cost Center',
                        availability: 'Availability',
                        isActive: 'Status',
                    }
                });

                return true;
            }

            return false;
        }
        catch (error) {
            //Vue.toasted.error(error);
        }
    },

    async initExtras ({ commit, rootState, dispatch }, data) {
        try {
			let onlyActive = !!data ? !data.showInactiveExtras : null // if we don't have data, we make the api call without onlyActive param
			if (!!localStorage.getItem('showInactiveExtras')) { // if we have the value saved in local storage, we use it to make the api call
				onlyActive = localStorage.getItem('showInactiveExtras') === 'false'
			}
            state.isLoadingExtras = true
            let response = await axios.get('/api/inventory/ListExtra', { params: {
				supplierId: rootState.user.account.supplierId,
				onlyActive: onlyActive
			}});
            state.isLoadingExtras = false

            if (response && response.status === 200 && response.data) {
                commit('INIT_EXTRAS', {
                    extras: response.data,
                    labels: {
                        name: 'Name',
                        code: 'Billing Product ID',
                        description: 'Description',
                        priceTotal: 'Price',
                        isActive: 'Status'
                    }
                });

                return true;
            }

            return false;
        }
        catch (error) {
            //Vue.toasted.error(error);
        }
    },

    // Initializes a list of events between dates.from and dates.to
    // (in YYYY-MM-DD format)

    async initEvents({ commit, rootState, dispatch }, dates) {
        try {
            let response = null;

            // Fetch events:
            // If we are on this modal window and we have a selected reservation,
            // this means we're rescheduling that same reservation, so we must
            // fetch similar events. Otherwise, we're adding a new, blank reservation
            // and we need to fetch ALL events.

            if (rootState.reservations.selectedReservation && rootState.reservations.selectedReservation.id !== undefined) {
                response = await axios.get('api/calendar/GetEventsToReschedule', { params: {
                    supplierId: rootState.user.account.supplierId,
                    bookingId: rootState.reservations.selectedReservation.id,
                    dateFrom: dates.from,
                    dateTo: dates.to
                }});
            }
            else {
                response = await axios.get('api/calendar/GetEvents', { params: {
                    supplierId: rootState.user.account.supplierId,
                    dateFrom: dates.from,
                    dateTo: dates.to
                }});
            }

            if (response && response.status === 200 && response.data) {
                commit('INIT_EVENTS', response.data.events);
                return true;
            }

            return false;
        }
        catch (error) {
            //Vue.toasted.error(error);
        }
    },

    // Initializes the events retrieved externally

    commitEvents: ({ commit }, events) => {
        commit('INIT_EVENTS', events);
    },

    // Adds an item (placebo for update method)
    // Parameters: { action: 'edit', object: 'category', table: 'categories', fields: { object } }

    addItem: ({ dispatch, rootState }, data) => {
        return new Promise((resolve, reject) => {
            dispatch('startFullScreenLoading');
            dispatch('updateItem', data).then((response) => {
                dispatch('stopFullScreenLoading');
                resolve(response);
            }).catch(function(error) {
                dispatch('stopFullScreenLoading');
                reject(error);
            });
        })
    },

    updateItem: ({ commit, dispatch, state }, data) => {
        if (!data.object || !data.action) {
            throw new Error('Invalid object or action on updateItem');
        }

        let object = data.object.charAt(0).toUpperCase() + data.object.slice(1);
        let action = data.action.charAt(0).toUpperCase() + data.action.slice(1);
        let pluralTable = data.table.charAt(0).toUpperCase() + data.table.slice(1);

        if(!state.isAddingItem){
            state.isAddingItem = true;

            return new Promise((resolve, reject) => {
                dispatch('startFullScreenLoading');
                axios.post('/api/inventory/' + action + object, data.fields).then((response) => {
                    state.isAddingItem = false;
                    dispatch('stopFullScreenLoading');
                    if (response && response.status === 200) {
                        dispatch('init' + pluralTable);
                        dispatch('closeModal');

                        Vue.toasted.success('Successfully saved', {duration: 2000});
                    }
                    resolve(response);
                    return response
                })
                .catch(function(error) {
                    dispatch('stopFullScreenLoading');
                    state.isAddingItem = false;
                    Vue.toasted.error('An error occurred', {duration: 2000});
                    reject(error);
                    return error
                });
            })

        }
    },

    updateClonedItem: ({ commit }, fields) => {
        commit('UPDATE_CLONED_ITEM', fields);
    },

    setSelectedItem: ({ commit }, data) => {
        commit('SET_SELECTED_ITEM', data);
    },

    setSelectedExtra: ({ commit }, data) => {
        commit('SET_SELECTED_EXTRA', data);
    },

    setSelectedProduct: ({ commit }, data) => {
        commit('SET_SELECTED_PRODUCT', data);
    },

    clearSelectedItem: ({ commit }) => {
        commit('CLEAR_SELECTED_ITEM');
    },
    clearSelectedExtra: ({ commit }) => {
        commit('CLEAR_SELECTED_EXTRA');
    },

    clearClonedItem: ({ commit }) => {
        commit('CLEAR_CLONED_ITEM');
    },

    pushEvent: ({ dispatch, commit, getters }, event) => {
        commit('SET_EVENT', event);
    },

    updateroductEditPriceData: ({state, commit}, payload) => {
        commit('UPDATE_EDIT_PRICE_DATA', payload);
    },

    setGroupPrices: ({ commit }, payload) => {
        commit('SET_GROUP_PRICES', payload);
    },

    cleanGroupPrices: ({ commit }, payload) => {
        commit('CLEAN_GROUP_PRICES', payload);
    },

    addRouteToPickups: ({state}, payload) => {
        state.isAddingRouteToPickups = true;
        state.pickupRoutes.push(payload);
        state.isAddingRouteToPickups = false;
    }
}

const mutations = {
    NORMALIZE_GENDER_PRICES_DEPS(state) {
        if (state.priceGroupSelected && state.priceGroupSelected.length > 0) {
            state.priceGroupSelected.forEach(item => {
                if (item.genderPriceDependencies.length > 0) {
                    item.genderPriceDependencies.forEach(gpd => {
                        const gpdeps = gpd.genderPriceDependsOn;
                        if (gpdeps && gpdeps.audienceTypeGroup && gpdeps.audienceTypeDescription) {
                            const prefix = gpdeps.audienceTypeGroup + ' - ';
                            
                            if (gpdeps.audienceTypeDescription.startsWith(prefix)) {
                                gpdeps.audienceTypeDescription = gpdeps.audienceTypeDescription.substring(prefix.length);
                            }
                        }
                    })
                }
            });
        }
    },

    CREATING_NEW_RESOURCE: (state, data) => {
        state.creatingNewResource = data
    },
    INIT_PRODUCTS: (state, data) => {
        state.products = data.products;
        state.productsLabels = data.labels;
    },

    INIT_EXTRAS: (state, data) => {
        state.extras = data.extras;
        state.extrasLabels = data.labels;
    },

    INIT_RESOURCES: (state, data) => {
        state.resources = data.resources;
        state.resourcesLabels = data.labels;
    },

    INIT_CATEGORIES: (state, data) => {
        state.categories = data.categories;
        state.categoriesLabels = data.labels;
    },

    INIT_EVENTS: (state, events) => {
        state.events = events;
    },

    SET_SELECTED_ITEM: (state, data) => {
        state.selectedItem = (data.id !== undefined) ? state[data.table].find(i => i.id === data.id) : null;
    },

    SET_SELECTED_EXTRA: (state, data) => {
        state.selectedExtra = data;
    },

    SET_SELECTED_PRODUCT: (state, data) => {
        state.selectedItem = data;
    },

    CLEAR_SELECTED_ITEM: (state) => {
        state.selectedItem = null;
    },

    CLEAR_SELECTED_EXTRA: (state) => {
        state.selectedExtra = null;
    },

    CLEAR_CLONED_ITEM: (state) => {
        state.clonedItem = null;
    },

    UPDATE_CLONED_ITEM: (state, fields) => {
        fields.groups.map(group => {
            if (group.passengerSettings && group.passengerSettings.format === 2) {
                if (group.productGenderPrices !== null || group.productGenderPrices.length > 0) {
                    group.productGenderPrices.map(gp => {
                        if (gp.tieredConfigurations === null) {
                            gp.tieredConfigurations = group.passengerSettings.tieredConfigurations[gp.hashedAudience]
                        }
                    })
                }
            }
        })

        state.clonedItem = fields;
    },

    SET_EVENT: (state, e) => {
        var exists = e.id ? state.events.find(evt => evt.id === e.id) : null;

        if (exists &&_.indexOf(state.events, exists) == -1) {
            return false;
        }
        else {
            // Add the new event and update the data (including id, etc.).
            // Currently randomizing an id for test purposes

            e.id = Math.floor(Math.random() * (30 - 12300)) + 12300;
            e.notes = [];
        }

        state.events.splice(state.events.length, 1, e);
    },

    SET_NOTE: (state, data) => {
        var e = state.events.find(evt => evt.id === data.event.id);

        if (e) {
            // Random id for now

            data.note.id = Math.floor(Math.random() * (30 - 12300)) + 12300;
            e.notes.splice(e.notes.length, 1, data.note);
        }
    },

    UPDATE_EDIT_PRICE_DATA: (state, payload) => {
        state.productEditPriceData = payload
    },

    SET_GROUP_PRICES: (state, payload) => {
        state.priceGroupSelected = payload;
    },

    CLEAN_GROUP_PRICES: (state, payload) => {
        state.priceGroupSelected = [];
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory.js